import React from 'react'
import LogoImage from '../../assets/logo.png';
export default function Logo() {
  return (
    <div>
      <img src={LogoImage} alt="Qtify" />
    </div>
  )
}
